<template>
  <billing-transfer-report v-if="enabled"/>
  <billing-professional-transfer-legacy v-else/>
</template>

<script>
import { mapState } from 'vuex';
import BillingTransferReport from './billingTransferReport.vue';
import BillingProfessionalTransferLegacy from './billingProfessionalTransferLegacy.vue';

export default {
  components: {
    BillingTransferReport,
    BillingProfessionalTransferLegacy,
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
    }),
    enabled() {
      const settings = this.user && this.user.branch && this.user.branch.settings
        ? this.user.branch.settings.insuranceBilling
        : null;
      return !!(settings && settings.enabled);
    },
  },
};
</script>
